import { createSlice } from "@reduxjs/toolkit";
import { endGlobalLoadingDispatch } from "../dispatch/loading/global-loading/end-global-loading";
import { startGlobalLoadingDispatch } from "../dispatch/loading/global-loading/start-global-loading";
import { RootState } from "../store";
import { LoadingState } from "../type/loading-state";
import {startCenterLoadingDispatch} from "../dispatch/loading/global-loading/start-center-loading";

const initialState: LoadingState = {
  globalLoading: false,
  isDim: true,
};

export const loadingSlice = createSlice({
  name: "loadingSlice",
  initialState,
  reducers: {
    startGlobalLoadingAction: startGlobalLoadingDispatch,
    endGlobalLoadingAction: endGlobalLoadingDispatch,
    startCenterLoadingAction: startCenterLoadingDispatch
  },
});

export const { startGlobalLoadingAction, endGlobalLoadingAction, startCenterLoadingAction } =
  loadingSlice.actions;

export const loadingState = (state: RootState) => state.loading;

export default loadingSlice.reducer;
